import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "var(--color-black)",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.998 12.665a.667.667 0 0 1-.666-.667V8.665H3.998a.667.667 0 0 1 0-1.333h3.334V3.998a.667.667 0 1 1 1.333 0v3.334h3.333a.667.667 0 1 1 0 1.333H8.665v3.333a.667.667 0 0 1-.667.667",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }